(function ($, Drupal, window, document) {
  "use strict";

  const processTextNode = (node, terms) => {
    const text = node.nodeValue;
    for (const term in terms) {
      const regex = new RegExp(`\\b${term}\\b`, 'g');
      if (regex.test(text)) {
        node.nodeValue = text.replace(
          regex,
          `<span class="glossary-term" data-tippy-content="${terms[term]}">${term}</span>`
        );
        return true;
      }
    }
    return false;
  };

  const handleData = (terms) => {
    $('body *:not(script):not(style)').contents().each(function () {
      if (this.nodeType === 3 && processTextNode(this, terms)) {
        $(this).replaceWith(this.nodeValue);
      }
    });

    tippy('.glossary-term', {
      allowHTML: true,
      interactive: true,
      theme: 'material',
      animation: 'scale-subtle'
    });
  };

  Drupal.behaviors.glossary = {
    attach: function (context, settings) {

      // 🔑 Run only once, even on AJAX calls
      if (!$('body', context).once('glossary').length) {
        return;
      }

      fetch(`/${settings.path.currentLanguage || "en"}/api/glossary`)
        .then(res => res.json())
        .then(data =>
          handleData(
            data.reduce((acc, term) => {
              acc[term.name] = term.description;
              return acc;
            }, {})
          )
        )
        .catch(err => console.error("Error fetching glossary data:", err));
    },
  };
})(jQuery, Drupal, window, document);